import { useQuery } from "react-query"
import { queryKeys } from "../../client"
import api from "../../api"

const getData = async () => {
  const { data } = await api.get(`/task-defects`)
  
  return data.data
}

export const useTaskDefects = () => {
  const { data, ...props } = useQuery(
    queryKeys.TASK_DEFECTS,
    () => getData(),
  )
  return { data, ...props }
}
